import { ProductType } from '@/constants/product/product';
import type { Product, SimpleProduct, VariationProduct } from '@/models/product/product';

export const getProductEffectivePrice = (product: SimpleProduct | VariationProduct) => {
  if (product.salePrice) {
    return product.salePrice;
  }
  return product.originalPrice;
};

/**
 * Returns the simple product or variable product  info from a product
 * @param product - The product to get the simple product or variable product info from
 * @returns The simple product info
 */
export const getLowestPriceProductBasicInfo = (product: Product): VariationProduct | SimpleProduct => {
  if (product.type === ProductType.Simple) {
    return product;
  }

  const lowestPriceProduct = product.variations.sort(
    (a: VariationProduct, b: VariationProduct) => getProductEffectivePrice(a) - getProductEffectivePrice(b),
  )[0];

  return {
    ...product,
    type: lowestPriceProduct.type,
    originalPrice: lowestPriceProduct.originalPrice,
    salePrice: lowestPriceProduct.salePrice,
  };
};

/**
 * Normalizes a product category string for consistent comparison
 * @param category - The category string to normalize
 * @returns Normalized category string
 */
export function normalizeCategory(category: string): string {
  // First decode HTML entities
  const decodedCat = category.replace(/&amp;/g, '&');

  // Then convert to lowercase and normalize spaces and special characters
  return decodedCat
    .toLowerCase()
    .replace(/[&]/g, '-') // Replace & with -
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/(?:^-)|(?:-$)/g, ''); // Remove leading/trailing hyphens
}
